<template>
	<section class='knd-story knd-scroll-video' :class="'container-' + id">
			<div class="scroll-bound" ref='scrollbound'>
					<div class="content" ref="content">
						<video ref="video" preload muted playsinline>
							<!-- :poster="getAsset(this.poster)"> -->
							<source ref="video" 
								:src="require(`@/assets/video/${videoUrl}`)"
								type="video/mp4">
								Your browser doesn't support HTML5 video tag.
						</video>
<!-- 						<div class='video-gradient'></div>
						<div class='knd-scroll-video-label'>Scroll naar beneden</div>
 -->					</div>
				<div class='steps'> 
				<div 
					v-for="(stap, index) in content" 
					:key="index"
					class="step">
					<div class="tekstvak">
						<p v-html="stap.tekst"></p>
					</div>
				</div>
					</div>
					<div class='step step--empty'></div>
				</div>
	</section>
</template>

<script>

	import './index.scss';

	const vueObject = {
		components: {},
		props: ['id', 'desktopUrl', 'mobielUrl', 'poster', 'content'],
		data: function() {
			let width = window.screen.width;

			let videoUrl = width < 640 ? this.mobielUrl : this.desktopUrl;

			return {
				req: undefined,
				videoUrl
			}
		},
		mounted () {
			this.setVideoScroll();

			// for safari mobile to show
			this.$refs.video.load();
		},

		methods: {
			getVideo(str){
				return require(str);
			},

			setVideoScroll() {
				let bound = this.$refs.scrollbound;
				let vid = this.$refs.video;
				vid.addEventListener('loadedmetadata', () => {
					this.registerVideo(bound, vid);
					vid.currentTime = 1;
				});
			},

			registerVideo(bound, video) {
				const scrollVideo = ()=> {
					const distanceFromTop = window.scrollY + bound.getBoundingClientRect().top;
					const rawPercentScrolled = (window.scrollY - distanceFromTop) / (bound.scrollHeight - window.innerHeight);
					const percentScrolled = Math.min(Math.max(rawPercentScrolled, 0), 1);

					if(video.currentTime !== video.duration * percentScrolled) {
						video.currentTime = video.duration * percentScrolled;						
					}
					this.req = requestAnimationFrame(scrollVideo);
				}
				this.req = requestAnimationFrame(scrollVideo);
			}
		}
	}

	export default vueObject;
</script>